import React, { FC } from 'react';
import { Grid, GridItem } from '../../lib/components/Grid';
import { useExamAnalysisContext } from '../../providers/ExamAnalysisProvider';
import AreaTags from '../AreaTags';
import { UfSelect, InstitutionSelect } from '../Selects';

const ExamAnalysisForm: FC = () => {
  const {
    actions,
    form,
  } = useExamAnalysisContext();

  return (
    <Grid columnGap={2} rowGap={2} className="mb-2">
      <GridItem col={4} colLg={2}>
        <UfSelect
          value={form.uf}
          onChange={(v): void => actions.onUf(v.value)}
        />
      </GridItem>
      <GridItem col={8} colLg={4}>
        <InstitutionSelect
          value={form.institution}
          onChange={(v): void => actions.onInstitution(v.label)}
          region={form.uf}
          disabled={!form.uf}
        />
      </GridItem>
      <GridItem col={12}>
        <AreaTags
          values={form.area}
          onChange={actions.onArea}
        />
      </GridItem>
    </Grid>
  );
};

export default ExamAnalysisForm;
